@for (item of resultsContext(); track $index) {
  <div
    class="results-wrapper-viewport__item"
    (click)="goToSelectedSearchResult($index)"
    (keyup.enter)="goToSelectedSearchResult($index)"
    tabindex="0"
  >
    <div class="results-wrapper-viewport__item-header">
      <span class="results-wrapper-viewport__item-header-title" nrEllipsis>
        {{ item.chapterName }}
      </span>
      <span class="results-wrapper-viewport__item-header-percentage">
        {{ item.percentage | number: '1.0-0' }}%
      </span>
    </div>
    <span class="results-wrapper-viewport__item-context">
      ...{{ item.before }}
      <span
        class="results-wrapper-viewport__item-context-highlight"
        [class.selected]="$index === index()"
      >
        {{ item.word }}
      </span>
      {{ item.after }}...
    </span>
  </div>
}
